<div class="demo-scroll-container">
    <upp-scrollable [scrollbar]="'y'">
        <div class="demo-content">
            <h2>Order Configuration</h2>
            <p class="demo-description">Configure shipping and payment using <code>upp-select</code> with FormGroup and standalone modes.</p>

            <div class="demo-controls">
    <ion-button size="small" (click)="toggleDisabled()">Disabled: {{ isDisabled }}</ion-button>
</div>

<!-- Shipping country (FormGroup) -->
<div class="demo-section" [formGroup]="form">
    <div class="demo-field">
        <upp-select formControlName="country" title="Shipping country">
            <upp-select-item>
                <ion-item lines="none">
                    <ion-icon name="globe-outline" slot="start"></ion-icon>
                    <ion-label>{{ selectedCountryLabel }}</ion-label>
                </ion-item>
            </upp-select-item>
            <upp-select-list>
                <upp-select-option *ngFor="let country of countries" [value]="country.value">
                    <ion-item lines="none" button>
                        <ion-label>{{ country.label }}</ion-label>
                    </ion-item>
                </upp-select-option>
            </upp-select-list>
        </upp-select>
        <span class="demo-label">Selected: {{ form.get('country')?.value }}</span>
    </div>
</div>

<!-- Payment method (standalone) -->
<div class="demo-section">
    <div class="demo-field">
        <upp-select [disabled]="isDisabled" title="Payment method" (Changed)="onPaymentChanged($event)">
            <upp-select-item>
                <ion-item lines="none">
                    <ion-icon name="card-outline" slot="start"></ion-icon>
                    <ion-label>{{ selectedPaymentLabel }}</ion-label>
                </ion-item>
            </upp-select-item>
            <upp-select-list>
                <upp-select-option *ngFor="let method of paymentMethods" [value]="method.value">
                    <ion-item lines="none" button>
                        <ion-label>{{ method.label }}</ion-label>
                    </ion-item>
                </upp-select-option>
            </upp-select-list>
        </upp-select>
        <span class="demo-label">Selected: {{ paymentMethod || 'none' }}</span>
    </div>
</div>
        </div>
    </upp-scrollable>
</div>
